import { TableHeaderCustomContent } from 'cdk-radial';
import styled from 'styled-components';

export const StyledTableHeaderCustomContent = styled(TableHeaderCustomContent)`
  display: flex;
`;

export const StyledIndeterminateProgressBar = styled.div`
  margin: 0 auto;
  width: 30%;
`;

export const StyledAggridHeader = styled.div`
  .ag-header-cell {
    padding: 0 1rem 0 1rem !important;
  }
  .ag-group-value {
    display: flex;
  }
  .ag-cell {
    display: flex !important;
  }
  .ag-cell-wrapper {
    overflow: hidden;
    text-overflow: ellipse;
  }
  .ag-pinned-right-cols-container {
    margin-right: 0px !important;
  }
  .hide-table-border .ag-root-wrapper {
    border: none;
  }
`;
